import { Column } from "components/Table/Table";
import { ClientRefsAddress, IActionItem } from "generated/graphql";

export const useClientAddressModal = (text: any): Column<ClientRefsAddress | any>[] => {
  return [
    {
      title: text.all.address,
      field: "address",
      render: ({ address }) => address?.address,
    },
    {
      title: "contact",
      field: "contact",
      render: ({ lastname, firstname }) => `${firstname} ${lastname}`,
    },
    {
      title: text.all.phone_number,
      field: "phone_number",
    },
  ];
};

export const useActionItemColumns = (text: any): Column<IActionItem>[] => {
  return [
    {
      title: "code",
      field: "code",
      render: ({ code }) => code,
    },
    {
      title: text.all.description,
      field: "description",
      render: ({ description }) => description,
    },
    {
      title: text.all.quantity,
      field: "quantity",
      render: ({ quantity }) => +quantity,
    },
  ];
};
